import { FC } from 'react'
import { Row, Col, Text, Breadcrumb, Button } from '@/client/components'
import { useRouterPush } from '@/client/hooks'
import { ROUTER_PATH } from '@/client/utils'
import * as S from './styles'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({
  breadcrumb,
  title,
  subtitle,
  description,
  button_label,
  button_link,
  video_link
}) => {
  const { routerPush, defaultLocale } = useRouterPush()

  return (
    <S.Featured>
      <Row>
        <Col>
          <Breadcrumb pages={breadcrumb} />
        </Col>
      </Row>
      <Row>
        <Col>
          <S.MainFeatured>
            <S.LeftFeatured>
              <Text as='h2' color='primary' family='heading'>
                {subtitle}
              </Text>
              <Text as='h1' size='h3' family='heading' weight='bold' margin='0 0 2.5rem'>
                {title}
              </Text>
              <Text color='weak' margin='0 0 2rem' itemProp='description'>
                {description}
              </Text>

              <Button onClick={() => window.open(button_link, '_blank')}>{button_label}</Button>
            </S.LeftFeatured>

            <S.Video>
              <video width='770' height='433' controls>
                <source type='video/mp4' src={video_link} />
                <a href={video_link}>{video_link}</a>
                Your browser does not support the video tag.
              </video>
            </S.Video>
          </S.MainFeatured>
        </Col>
      </Row>
    </S.Featured>
  )
}
